import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  downloadBox: {
    marginTop: 8,
    marginBottom: 16,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '0 24px',
    '&:focus': {
      border: 'inherit',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      paddingTop: 0,
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    }
  },
  downloadButton: {
    display: 'flex',
    alignItems: 'flex-start',
    wordBreak: 'break-word',
    padding: '16px 0',
    borderBottom: `1px solid ${theme.color.greys[15]}`,
  },
  expandButton: {
    alignItems: 'center',
    gap: 4,
  },
  fadeIn: {
    opacity: 0,
    animation: '$fadeIn 0.3s ease forwards',
  }
}), { name: 'DocumentsList', index: StylesIndexInjections.UI_MOLECULES });
